export const DESIGN_CONTROLS_SOURCE = 'product-development';
